// extracted by mini-css-extract-plugin
module.exports = {"BooksCalendar":"BooksCalendar_BooksCalendar__2ReEv"};